import React from "react";
import { calendarDateKey } from "./CalendarEvent";

const DAYS = ["S", "M", "T", "W", "T", "F", "S"];

export default function CalendarYear({ date, events, onSelectMonth }) {
  const year = date.getFullYear();
  const todayKey = calendarDateKey(new Date());
  return (
    <div className="calendar-year-grid" aria-label={`${year} year calendar`}>
      {Array.from({ length: 12 }, (_, month) => {
        const first = new Date(year, month, 1);
        const end = new Date(year, month + 1, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const monthlyEvents = events.filter(
          (event) => event.start < end && event.end >= first,
        );
        return (
          <button
            key={month}
            type="button"
            className="calendar-year-month"
            onClick={() => onSelectMonth(first)}
            aria-label={`Open ${first.toLocaleDateString("en", { month: "long", year: "numeric" })}, ${monthlyEvents.length} events`}
          >
            <span className="calendar-year-month-heading">
              <strong>
                {first.toLocaleDateString("en", { month: "long" })}
              </strong>
              <span>{monthlyEvents.length || ""}</span>
            </span>
            <span className="calendar-mini-weekdays" aria-hidden="true">
              {DAYS.map((day, index) => (
                <span key={index}>{day}</span>
              ))}
            </span>
            <span className="calendar-mini-days" aria-hidden="true">
              {Array.from({ length: 42 }, (_, index) => {
                const day = index - first.getDay() + 1;
                if (day < 1 || day > daysInMonth) return <span key={index} />;
                const current = new Date(year, month, day);
                const next = new Date(year, month, day + 1);
                const hasEvents = monthlyEvents.some(
                  (event) => event.start < next && event.end >= current,
                );
                return (
                  <span
                    key={index}
                    className={`${calendarDateKey(current) === todayKey ? "is-today" : ""} ${hasEvents ? "has-events" : ""}`}
                  >
                    {day}
                    {hasEvents && <i />}
                  </span>
                );
              })}
            </span>
          </button>
        );
      })}
    </div>
  );
}
